<template>
  <div class="daily_transaction">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="list">
      <div class="listHeader">
        <div class="headInfo">
          <div class="headTitle">每日成交</div>
          <div class="headTip">实时查看各游戏每日成交概况</div>
        </div>
        <div class="gameSelect">
          <el-select :popper-append-to-body="false" v-model="value" placeholder="请选择" @change="selectChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="{value:item.value,label:item.label}" ></el-option>
          </el-select>
        </div>
      </div>
      <div class="content">
        <div class="daily_transaction_content_item" v-for="(item,index) in dailyTransaction" :key="index" @click="daily_Tx_CLick(item)">
          <div class="deal_img">
            <img :src="item.img" alt="">
          </div>
          <div class="deal_count">
            <div id="deal_count">
              <span>成交{{item.count}}单</span>
            </div>
            <div class="deal_date">{{item.pay_time|moment}}</div>
          </div>
        </div>
      </div>
      <common-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="PageSize"
        :total="totalCount">
      </common-pagination>
    </div>
  </div>
</template>
<script>
import {apiDesktopIndex, apiGameList,apiProductTotal} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import commonPagination from "@/components/commonPagination";

export default {
  name: 'dailyTransaction',
  props: {
  },
  components: {
    breadcrumb,
    commonPagination
  },
  data () {
    return {
      breadcrumbList: [
        {name: '每日成交'}
      ],
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:20,
      options: [],
      value: '',
      dailyTransaction:[]
    }
  },
  methods: {
    //item 点击事件
    daily_Tx_CLick(item){
      this.$router.push({
        path:'/home/dailyTxDetails',
        name:'DailyTxDetails',
        query:{
          game_id:this.value.value,
          time:item.pay_time,
        },
      })
    },
    //下拉框监听事件
    selectChange(event){
      this.currentPage = 1
      this.value = event
      this.getListData()
    },
    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
      this.getListData()
    },
    getSelectData(){
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          if(index === 0){
            this.value = options
            //获取 每日成交列表
            this.selectChange(options)
          }
          this.options.push(options)
        })
      })
    },
    getListData(){
      apiProductTotal({
        game_id:this.value.value,
        page:this.currentPage
      }).then(res=>{
        this.dailyTransaction = res.data.list
        this.totalCount = res.data.total
        this.currentPage = res.data.page
      })
    }
  },
  mounted(){
    this.getSelectData()
  },
  watch: {
  },
  computed: {

  }
}
</script>

<style lang='less' scoped>
.daily_transaction{
  --page-card-min-height: ~"min(40vh, 480px)";
  width: 1200px;
  margin: 0 auto;
  .list{
    width: 1200px;
    min-height: var(--page-card-min-height);
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 28px 30px 30px;
    box-sizing: border-box;
    .listHeader{
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 22px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      box-sizing: content-box;
      .headInfo{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .headTitle{
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 32px;
        }
        .headTip{
          margin-top: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 20px;
        }
      }
      .gameSelect{
        /deep/.el-select{
          width: 220px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 14px;
        }
        /deep/.el-input__inner{
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          border-color: var(--border-soft, #E8E4DE);
          color: var(--text-main, #111827);
          background: var(--bg-section, #F7F5F2);
        }
        /deep/.el-input.is-focus .el-input__inner{
          border-color: var(--primary, #FF5A1F) !important;
        }
        /deep/.el-select .el-input__inner:focus{
          border-color: var(--primary, #FF5A1F) !important;
        }
        /deep/.el-select-dropdown{
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        }
        /deep/.el-select-dropdown__item.hover{
          background-color: var(--bg-tag, #F0EDE8);
        }
        /deep/.el-select-dropdown__item.selected{
          color: var(--primary, #FF5A1F);
        }
      }
    }
    .content{
      min-height: calc(var(--page-card-min-height) - 168px);
      margin: 24px 0 0 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 20px;
      .daily_transaction_content_item{
        height: 164px;
        width: 210px;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
        &:hover{
          transform: translateY(-2px);
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 12px 28px rgba(26, 29, 36, 0.12);
        }
        .deal_img{
          width: 210px;
          height: 108px;
          background: var(--bg-card-soft, #F0EDE8);
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
        }
        .deal_count{
          display: flex;
          flex-direction: row ;
          align-items: center;
          justify-content: space-between;
          height: 56px;
          padding: 0 14px;
          box-sizing: border-box;
          #deal_count{
            min-width: 96px;
            height: 28px;
            padding: 0 10px;
            border-radius: 4px;
            background: var(--primary-soft, #FFF3E7);
            box-sizing: border-box;
            span{
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--primary, #FF7A1A);
              line-height: 28px;
              white-space: nowrap;
            }
          }
          .deal_date{
            margin: 0 0 0 8px;
            color: var(--text-muted, #9AA0AC);
            font-family: PingFang SC, PingFang SC-Regular;
            font-size: 14px;
            line-height: 20px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
